export default __webpack_public_path__ + "static/media/Background_00248.2f79c7d5.png";